export const valorConDescuento = ({valor, descuento}) => {

    let precioFinal = valor - (valor * (descuento/100))

    return precioFinal


}